import http from "./httpService";
import axios from "axios";
import { apiUrl } from "../config.json";
import { toast } from "react-toastify";
import { is } from "date-fns/esm/locale";
//api/GetCashU_MT_Filer_ALL_New/{isreply}/{isdelete}/{username}/{replyidlast}
const getAllDreams_Reply_delete = apiUrl + "/api/GetCashU_MT_Filer_ALL_Del_Rep/false/false/";
const getAllDreams = apiUrl + "/api/GetCashU_MT_Filer_ALL/false/false/";
const POSTLockedـDelete_Dream = apiUrl + "/api/PostCashU_MT_lock_Delete";
const PostCashU_MT_UNLOCK = apiUrl + "/api/PostCashU_MT_UNLOCK";
const get_New_Delete_Locked_Replyed_Dreams =
  apiUrl + "/api/GetCashU_MT_Filer_ALL_New/false/false/";
const PostDream = apiUrl + "/api/PostCashU_MT_Save";
const PostStopSendDream = apiUrl + "/api/PostCashU_MT_Stop";
const PostEditDream = apiUrl + "/api/PostCashU_MT_Edit";
const getUpdateWorkCount = apiUrl + "/api/GetCashU_MT_Get_Work_Reports/";
const GetDreamsPerMufasser = apiUrl + "/api/GetCashU_MT_Filer_ALL_Mufasser";
const SearchDreamsPerMobile = apiUrl + "/api/GetSearshByMobile/";
const SearchDreamsPerWords = apiUrl + "/api/GetSearch";
//const GetAllReplyedDreamInMonth = apiUrl + "/api/TB_OPTOut";
const SearchDreamsPerWordsNoPrivate = apiUrl + "/api/GetSearch_Not_private";
const apiEndpointOPTOUT = apiUrl + "/api/TB_OPTOut";

const getalldreamapi_NONREPLY_After_60 = apiUrl + "/api/CashU_MT_1/60/false/false";
const getalldreamapi_NONREPLY_Befor_60 = apiUrl + "/api/CashU_MT_2/60/false/false";

const getalldreamapi_DELETE_before_30 = apiUrl + "/api/CashU_MT_6/30/true";
const getalldreamapi_DELETE_Before_60 = apiUrl + "/api/CashU_MT_4/60/false";

const getalldreamapi_Before_30 = apiUrl + "/api/CashU_MT_3/30";
const getalldreamapi_REPLY_Before_2 = apiUrl + "/api/CashU_MT_5/2/false";

const postPersonalStatus = apiUrl + "/api/PostCashU_MT_PS/PS";

const postCustomerRate = apiUrl + "/api/PostCashU_MT_CR/CR";

const postPrivate = apiUrl + "/api/PostCashU_MT_PR/PR";

const postDreamAdmin = apiUrl + "/api/PostCashU_MT_Admin/sent";
const postDreamAdminMuraqeeb = apiUrl + "/api/PostCashU_MT_AdminMuraqeeb/sent";
const getLockDream_private = apiUrl + "/api/GetCashU_MT_2_private/";

const getLockDream_Mob = apiUrl + "/api/GetCashU_MT_1_Lock/";

const getLockDream_Mob_Admin = apiUrl + "/api/GetCashU_MT_Admin_Lock/";

const getLockDream_ReplyID = apiUrl + "/api/GetCashU_MT_2_Lock/";
//const PostSendMessage = apiUrl +"api/PostCashU_MT_Save";
const getDream_Rep = apiUrl + "/api/GetCashU_MT_Rep/";

export function getRep_(userName: string) {
  const data = localStorage.getItem("token");
  try {
    if (userName.length > 20) {
      userName = userName.replace("@salmustasharak.com", "");

      return http.get(getDream_Rep + userName, {
        headers: { Authorization: `Bearer ${data}` }
      });
    } else {
      let userName = localStorage.getItem("userName");
      if (userName.length > 20) {
        userName = userName.replace("@salmustasharak.com", "");

        return http.get(getDream_Rep + userName, {
          headers: { Authorization: `Bearer ${data}` }
        });
      }
    }
  } catch (ex) {

    return;
  }
}

export function CustomerRate(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    console.log(Dream);
    const data = localStorage.getItem("token");
    return http.post(postCustomerRate, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}


export function PrivatePerson(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    console.log(Dream);
    const data = localStorage.getItem("token");
    return http.post(postPrivate, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}





export function PersonalStatus(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    console.log(Dream);
    const data = localStorage.getItem("token");
    return http.post(postPersonalStatus, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}


export function DreamAdminMuraqeeb(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    const data = localStorage.getItem("token");
    return http.post(postDreamAdminMuraqeeb, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function DreamAdmin(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    const data = localStorage.getItem("token");
    return http.post(postDreamAdmin, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function PostDream_(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    const data = localStorage.getItem("token");
    return http.post(PostDream, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }

}


export function LockDream_private(ReplyID: Number, isprivate: Boolean) {
  try {
    const data = localStorage.getItem("token");
    return http.get(getLockDream_private + ReplyID + "/" + isprivate,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }

}

export function LockDream_Mob(mob: string, islock: Boolean) {
  try {
    let userName = localStorage.getItem("userName");
    userName = userName.replace("@salmustasharak.com", "");
    mob = mob.replace('+', '');
    const data = localStorage.getItem("token");
    return http.get(getLockDream_Mob + mob + "/" + islock + "/" + userName,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function LockDream_Mob_Admin(mob: string, islock: Boolean) {

  try {
    let userName = localStorage.getItem("userName");
    userName = userName.replace("@salmustasharak.com", "");
    mob = mob.replace('+', '');
    const data = localStorage.getItem("token");
    return http.get(getLockDream_Mob_Admin + mob + "/" + islock + "/" + userName,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function LockDream_ReplyID(ReplyID: Number, islock: Boolean) {
  try {
    let userName = localStorage.getItem("userName");
    userName = userName.replace("@salmustasharak.com", "");
    const data = localStorage.getItem("token");
    return http.get(getLockDream_ReplyID + ReplyID + "/" + islock + "/" + userName,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}


export function alldreamapi_NONREPLY_After_60() {
  try {
    const data = localStorage.getItem("token");
    return http.get(getalldreamapi_NONREPLY_After_60,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function alldreamapi_NONREPLY_Befor_60() {
  try {

    return axios.get('https://api2.ahlamkom.net/msg/sdo/',
      { headers: { Authorization: 'Basic YWRtaW46TW9oYW5uYWRANTY3OQ==' } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }

}
export function alldreamapi_DELETE_before_30() {
  try {

    const data = localStorage.getItem("token");
    return http.get(getalldreamapi_DELETE_before_30,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }

}

export function alldreamapi_DELETE_Before_60() {
  try {
    const data = localStorage.getItem("token");
    return http.get(getalldreamapi_DELETE_Before_60,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }

}

export function alldreamapi_Before_30() {
  try {
    const data = localStorage.getItem("token");
    return http.get(getalldreamapi_Before_30,
      { headers: { Authorization: `Bearer ${data}` } });

  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function alldreamapi_REPLY_Before_2() {
  try {
    const data = localStorage.getItem("token");
    return http.get(getalldreamapi_REPLY_Before_2,
      { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }

}



export function getAllDreams_Reply_delete_(userName: string) {
  const data = localStorage.getItem("token");
  try {
    if (userName.length > 20) {
      userName = userName.replace("@salmustasharak.com", "");

      return http.get(getAllDreams_Reply_delete + userName, {
        headers: { Authorization: `Bearer ${data}` }
      });
    } else {
      let userName = localStorage.getItem("userName");
      if (userName.length > 20) {
        userName = userName.replace("@salmustasharak.com", "");

        return http.get(getAllDreams_Reply_delete + userName, {
          headers: { Authorization: `Bearer ${data}` }
        });
      }
    }
  } catch (ex) {
    toast.error("يوجد خطأ باسم المستخدم يرجى الدخول من جديد  ", {
      position: toast.POSITION.BOTTOM_CENTER
    });
    return;
  }
}




export function getAllDreams_(userName: string) {
  const data = localStorage.getItem("token");
  try {
    if (userName.length > 20) {
      userName = userName.replace("@salmustasharak.com", "");

      return http.get(getAllDreams + userName, {
        headers: { Authorization: `Bearer ${data}` }
      });
    } else {
      let userName = localStorage.getItem("userName");
      if (userName.length > 20) {
        userName = userName.replace("@salmustasharak.com", "");

        return http.get(getAllDreams + userName, {
          headers: { Authorization: `Bearer ${data}` }
        });
      }
    }
  } catch (ex) {
    toast.error("يوجد خطأ باسم المستخدم يرجى الدخول من جديد  ", {
      position: toast.POSITION.BOTTOM_CENTER
    });
    return;
  }
}
export function getUpdateWorkCount_(userName: string) {
  const data = localStorage.getItem("token");
  try {
    if (userName.length > 20) {
      userName = userName.replace("@salmustasharak.com", "");

      return http.get(getUpdateWorkCount + userName, {
        headers: { Authorization: `Bearer ${data}` }
      });
    } else {
      let userName = localStorage.getItem("userName");
      if (userName.length > 20) {
        userName = userName.replace("@salmustasharak.com", "");

        return http.get(getUpdateWorkCount + userName, {
          headers: { Authorization: `Bearer ${data}` }
        });
      }
    }
  } catch (ex) {
    toast.error("يوجد خطأ باسم المستخدم يرجى الدخول من جديد  ", {
      position: toast.POSITION.BOTTOM_CENTER
    });
    return;
  }
}
export function saveOPTOUT(mob) {
  /*   if (Dream._id) {
    const body = { ...Dream };
    delete body._id;
    return http.put(DreamUrl(Dream._id), body);
  } */
  try {
    const data = localStorage.getItem("token");
    return http.post(apiEndpointOPTOUT, mob, { headers: { Authorization: `Bearer ${data}` } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}
export function get_New_Delete_Locked_Replyed_Dreams_(userName: string, replyidlast: int) {
  const data = localStorage.getItem("token");
  try {
    if (userName.length > 20) {
      userName = userName.replace("@salmustasharak.com", "");

      return http.get(get_New_Delete_Locked_Replyed_Dreams + userName + '/' + replyidlast, {
        headers: { Authorization: `Bearer ${data}` }
      });
    } else {
      let userName = localStorage.getItem("userName");
      if (userName.length > 20) {
        userName = userName.replace("@salmustasharak.com", "");

        return http.get(get_New_Delete_Locked_Replyed_Dreams + userName + '/' + replyidlast, {
          headers: { Authorization: `Bearer ${data}` }
        });
      }
    }
  } catch (ex) {
    toast.error("يوجد خطأ باسم المستخدم يرجى الدخول من جديد  ", {
      position: toast.POSITION.BOTTOM_CENTER
    });
    return;
  }

  //let userName = localStorage.getItem("userName");
}

export function GetDreamsPerMufasser_(words: string) {
  try {
    const data = localStorage.getItem("token");
    return http.get(GetDreamsPerMufasser + words, { headers: { Authorization: `Bearer ${data}`, } });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

//SearchDreamsPerWordsNoPrivate   

export function SearchDreamsPerWordsNoPrivate_(words) {
  const data = localStorage.getItem("token");
  return http.get(SearchDreamsPerWordsNoPrivate + words, { headers: { Authorization: `Bearer ${data}`, } });

}
export function SearchDreamsPerWords_(words) {
  const data = localStorage.getItem("token");
  return http.get(SearchDreamsPerWords + words, { headers: { Authorization: `Bearer ${data}`, } });
}

export function SearchDreamsPerMobile_(mob) {
  const data = localStorage.getItem("token");
  return http.get(SearchDreamsPerMobile + mob, { headers: { Authorization: `Bearer ${data}` } });
}

// export function PostDream_(Dream) {
//   /*   if (Dream._id) {
//       const body = { ...Dream };
//       delete body._id;
//       return http.put(DreamUrl(Dream._id), body);
//     } */
//   const data = localStorage.getItem("token");
//   return http.post(PostDream, Dream, {
//     headers: { Authorization: `Bearer ${data}` }
//   });
// }

export function PostStopSendDream_(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    const data = localStorage.getItem("token");
    return http.post(PostStopSendDream, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function PostEditDream_(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    const data = localStorage.getItem("token");
    return http.post(PostEditDream, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}
//PostCashU_MT_UNLOCK


export function PostCashU_MT_UNLOCK_(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    const data = localStorage.getItem("token");
    return http.post(PostCashU_MT_UNLOCK, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}

export function POSTLockedـDelete_Dream_(Dream) {
  /*   if (Dream._id) {
      const body = { ...Dream };
      delete body._id;
      return http.put(DreamUrl(Dream._id), body);
    } */
  try {
    const data = localStorage.getItem("token");
    return http.post(POSTLockedـDelete_Dream, Dream, {
      headers: { Authorization: `Bearer ${data}` }
    });
  } catch (ex) {
    toast.error("يوجد خطأ بالحفظ ", {
      position: toast.POSITION.BOTTOM_LEFT
    });
    if (ex.response && ex.response.status === 404)
      toast.error("This mob has already been deleted.");
  }
}



// WEBPACK FOOTER //
// ./src/services/dreamNewService.js